import { useState as c, useEffect as d } from "react";
import { inView as p } from "./atoms-v2952.js";
function l(e, { root: n, margin: r, amount: u, once: t = !1 } = {}) {
  const [i, s] = c(!1);
  return d(() => {
    if (!e.current || t && i)
      return;
    const f = () => (s(!0), t ? void 0 : () => s(!1)), o = {
      root: n && n.current || void 0,
      margin: r,
      amount: u
    };
    return p(e.current, f, o);
  }, [n, e, r, t, u]), i;
}
export {
  l as useInView
};
